var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.flag)?_c(_vm.getName,{ref:"componentRef",tag:"component",attrs:{"loading":_vm.loading,"isShowEdit":_vm.isShowEdit,"dialog-visible":_vm.flag},on:{"close":_vm.clickViewClose,"onClickView":_vm.onClickView}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188a3d3a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/clickView.vue
// module id = null
// module chunks = 